import { render, staticRenderFns } from "./AdminItemize.vue?vue&type=template&id=0c751df6"
import script from "./AdminItemize.vue?vue&type=script&lang=js"
export * from "./AdminItemize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports